<template>
  <v-stepper class="stepper" v-model="e1">
    <v-stepper-header>
      <v-stepper-step color="amber" :complete="e1 > 1" step="1"
        >Step 1</v-stepper-step
      >

      <v-divider></v-divider>

      <v-stepper-step color="amber" :complete="e1 > 2" step="2"
        >Step 2</v-stepper-step
      >

      <v-divider></v-divider>

      <v-stepper-step color="amber" step="3">Step 3</v-stepper-step>
    </v-stepper-header>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-stepper-items>
        <v-stepper-content step="1">
          <!-- creatorName -->
          <v-text-field
            v-model="creatorName"
            color="#3f51b5"
            :label="creatorNameLabel"
            :rules="[required]"
            :readonly="editFullName"
          >
          </v-text-field>

          <!-- university -->
          <v-text-field
            v-model="university"
            color="#3f51b5"
            :label="universityLabel"
            :rules="[required]"
          >
          </v-text-field>

          <!-- faculty -->
          <v-text-field
            v-if="!isExpert"
            v-model="faculty"
            color="#3f51b5"
            label="学部・学科(例：文学部英文学科)"
            :rules="[required]"
          ></v-text-field>

          <!-- grade -->
          <v-select
            v-if="!isExpert"
            v-model="grade"
            :items="grades"
            color="#3f51b5"
            :rules="[required]"
            label="学年"
            required
          ></v-select>

          <!-- area -->
          <v-select
            v-model="area"
            :items="areas"
            :rules="[required]"
            color="#3f51b5"
            label="地域"
            required
          ></v-select>

          <!-- course -->
          <v-select
            v-model="course"
            :items="courses"
            :rules="[required]"
            color="#3f51b5"
            label="コース"
            required
          ></v-select>

          <!-- experiencePeriod -->
          <v-select
            v-model="experiencePeriod"
            color="#3f51b5"
            :items="experiencePeriods"
            :rules="[required]"
            label="経験期間"
            required
          ></v-select>

          <v-btn color="amber" @click="e1 = 2">
            次へ
          </v-btn>

          <v-btn text @click="e1 = 1">戻る</v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">
          <label>使用技術(複数選択可)</label>
          <!-- skill -->
          <v-chip-group
            v-model="skills"
            column
            multiple
            active-class="indigo white--text"
          >
            <v-chip
              pill
              v-for="(skill, index) in SKILLS"
              :key="index"
              :value="skill"
              >{{ skill }}</v-chip
            >
          </v-chip-group>

          <!-- releasedAt -->
          <label class="mt-2 d-block">リリース日</label>
          <input
            type="date"
            v-model="releasedAt"
            :rules="[required]"
            class="d-block releasedAt"
          />

          <!-- productName -->
          <v-text-field
            v-model="productName"
            color="#3f51b5"
            :label="productNameLabel"
            :rules="[required]"
          >
          </v-text-field>

          <!-- productShortEx -->
          <v-textarea
            auto-grow
            rows="1"
            v-model="productShortEx"
            color="#3f51b5"
            label="プロダクトの説明(Short ver.)"
            :rules="[required]"
          >
          </v-textarea>

          <!-- productLongEx -->
          <v-textarea
            auto-grow
            rows="1"
            v-model="productLongEx"
            color="#3f51b5"
            label="プロダクトの説明(Long ver.)"
            :rules="[required]"
          >
          </v-textarea>

          <!-- productUrl -->
          <v-text-field
            v-model="productUrl"
            color="#3f51b5"
            label="プロダクトのURL(リリースURL)"
            :rules="[required]"
          >
          </v-text-field>

          <v-btn color="amber" @click="e1 = 3">
            次へ
          </v-btn>

          <v-btn text @click="e1 = 1">戻る</v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">
          <!-- productImage -->
          <p>プロダクト画像</p>
          <div class="image-explain">
            {{ productImgEx }}
          </div>
          <div class="product-thumnail">
            <img
              class="product-image"
              v-show="uploadedImage"
              :src="uploadedImage"
            />
            <div v-show="uploadedImage" class="product-preview">
              <p class="preview-item-name">{{ imageFile.name }}</p>
              <p class="preview-item-close" @click="remove">
                キャンセル
              </p>
            </div>
          </div>
          <label class="input-label">
            <div class="mb-5 select-file">ファイルを選択</div>
            <input
              class="image-input"
              type="file"
              multiple
              @change="onFileChange"
            />
          </label>

          <!-- モーダル -->
          <v-dialog v-model="dialog" persistent max-width="290">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mt-10" color="amber" v-bind="attrs" v-on="on">
                送信する
              </v-btn>
            </template>
            <v-card>
              <div v-if="isLoading">
                <v-card-title class="headline">
                  {{ message }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <router-link to="/">プロダクト一覧へ</router-link>
                </v-card-actions>
              </div>
              <div v-else>
                <v-card-title class="headline">
                  <p class="error-message">{{ errorMessage }}</p>
                  <v-text-field
                    v-model="enterdPassword"
                    color="#3f51b5"
                    label="パスワード"
                  >
                  </v-text-field>
                </v-card-title>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#3f51b5" text @click="cancel()" v-show="!load">
                    キャンセル
                  </v-btn>
                  <v-btn
                    :disabled="load"
                    :loading="load"
                    color="#3f51b5"
                    text
                    @click="upload(imageFile)"
                  >
                    送信する
                  </v-btn>
                </v-card-actions>
              </div>
            </v-card>
          </v-dialog>

          <v-btn class="mt-10" text @click="e1 = 2">戻る</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-form>
  </v-stepper>
</template>

<script>
import { db, app } from "@/firebase.config"
import { compressImage } from "@/lib/imageUtil"
import "firebase/storage"
import firebase from "firebase"
import {
  AREAS_ARRAY,
  COURSES_ARRAY,
  SKILLS,
  GRADES_ARRAY,
  EXPERIENCE_PERIODS_ARRAY,
} from "@/lib/const"

export default {
  name: "First",
  props: {
    type: String,
    isExpert: Boolean,
  },
  data: () => ({
    enterdPassword: "",
    correctPassword: "geekminpuro",
    dialog: false,
    load: false,
    isLoading: false,
    e1: 1,
    message: "送信する",
    errorMessage: "パスワードを入力してください",
    creatorName: "",
    university: "",
    faculty: "",
    grade: "",
    area: "",
    course: "",
    productName: "",
    productShortEx: "",
    productLongEx: "",
    productUrl: "",
    skills: [],
    releasedAt: "",
    experiencePeriod: "",
    grades: GRADES_ARRAY,
    areas: AREAS_ARRAY,
    courses: COURSES_ARRAY,
    experiencePeriods: EXPERIENCE_PERIODS_ARRAY,
    // 画像関連
    uploadedImage: "",
    imageFile: "",
    // validation
    valid: true,
    required: (value) => !!value || "必ず入力してください",
    editFullName: false,
  }),
  methods: {
    onFileChange: function(e) {
      const file = [...e.target.files]
      if (file !== undefined) {
        compressImage(file).then((result) => {
          this.uploadedImage = result.url
          this.imageFile = result.file
        })
      } else {
        this.imageFile = ""
      }
    },
    upload(file) {
      // password
      if (this.enterdPassword !== this.correctPassword) {
        this.errorMessage = "パスワードが違います"
        return
      }
      // バリデーション
      if (!this.$refs.form.validate()) {
        this.errorMessage = "入力欄に問題があります。"
        return
      }
      this.load = true
      const storageRef = app.storage().ref()
      const FileName = this.creatorName + "_" + this.productName
      const fileRef = storageRef.child("images/" + FileName)
      const releasedAt = new Date(this.releasedAt)
      fileRef
        .put(file)
        .then(() => fileRef.getDownloadURL())
        .then((url) => {
          // storage にアップロードしたファイルに対応するドキュメントを保存する
          return db.collection("minpuroproducts").add({
            userId: this.user.uid,
            creatorName: this.creatorName,
            university: this.university,
            faculty: this.faculty,
            grade: this.grade,
            area: this.area,
            course: this.course,
            productName: this.productName,
            productShortEx: this.productShortEx,
            productLongEx: this.saveProductLongEx,
            productUrl: this.productUrl,
            skills: this.skills,
            releasedAt: firebase.firestore.Timestamp.fromDate(releasedAt),
            experiencePeriod: this.experiencePeriod,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            url,
          })
        })
        .then(() => {
          this.isLoading = true
          this.load = false
          this.message = "送信完了！"
          setTimeout(() => {
            // this.uploadedImage = "";
            this.imageFile = ""
          }, 1000)
        })
        .catch(() => {
          this.load = false
          this.errorMessage = "送信中にエラーが発生しました。"
        })
    },
    cancel() {
      this.dialog = false
      this.errorMessage = "パスワードを入力してください"
    },
    remove() {
      this.uploadedImage = ""
      this.imageFile = ""
    },
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    SKILLS() {
      return Object.values(SKILLS)
    },
    creatorNameLabel() {
      if (this.editFullName) {
        return "名前(※編集不可。またこの情報は公開されません)"
      } else {
        return "名前(※この情報は公開されませんが、今後変更できません)"
      }
    },
    saveProductLongEx() {
      return this.productLongEx.replace(/\n/g, "\\n") //改行を改行コード(\n)に変換
    },
    productNameLabel() {
      if (this.type === "form") {
        return "プロダクト名(※今後変更できません)"
      } else {
        return "プロダクト名(※編集不可)"
      }
    },
    productImgEx() {
      if (this.type === "form") {
        return "サーバー負荷軽減のため画像サイズが10kB程度に自動で落ちます。\nアプリの全体像を投稿しようとするとぼやけるので、アイコンやタイトルなど、範囲を絞ることをおススメします。"
      } else {
        return "変更なしの場合はそのままで大丈夫です。\n変更する場合、サーバー負荷軽減のため画像サイズが10kB程度に自動で落ちます。\nアプリの全体像を投稿しようとするとぼやけるので、アイコンやタイトルなど、範囲を絞ることをおススメします。"
      }
    },
    universityLabel() {
      if (this.isExpert) {
        return "大学(空白区切り)(例：早稲田大学 立教大学)"
      } else {
        return "大学(例：早稲田大学)"
      }
    },
  },
  async mounted() {
    if (!this.user.uid) {
      this.$router.push("/signin")
    }

    const userFullName = await firebase
      .firestore()
      .collection("users")
      .doc(this.user.uid)
      .get()
      .then((doc) => {
        return doc.data()
      })
      .then((data) => {
        return data.fullName
      })
    this.creatorName = userFullName ? userFullName : ""
    if (this.creatorName) {
      this.editFullName = true
    }
  },
  watch: {
    isExpert: function() {
      this.course = this.isExpert ? "WebExpert" : ""
    },
  },
}
</script>

<style lang="scss">
.stepper {
  max-width: 600px;
  width: 90%;
  margin: 50px auto 0;

  .releasedAt {
    border: solid 1px #aaa;
  }

  .product-thumnail {
    width: 90%;
    margin: 0 10px;

    .product-image {
      width: 100%;
      height: 100%;
    }

    .product-image:hover {
      background: rgba(0, 0, 0, 0.2);
    }

    .product-preview {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .preview-item-name {
        font-size: 15px;
      }

      .preview-item-close {
        border: solid 1px #ddd;
        padding: 0 10px;
      }

      .preview-item-close:hover {
        cursor: pointer;
        background: #ddd;
      }
    }
  }

  .input-label {
    display: block;
  }

  .send-button {
    display: block;
    margin-left: auto;
  }
}

.select-file {
  display: inline;
  border: solid 1px #ddd;
  padding: 10px;
}

.select-file:hover {
  cursor: pointer;
  background: #ddd;
}

.image-explain {
  margin-bottom: 16px;
  font-size: 0.7rem;
  white-space: pre-line;
}

.image-input {
  display: none;
}

.headline {
  .error-message {
    font-size: 15px;
  }
}
</style>
